import React, { useEffect, useState } from 'react';
import { StepCartSummarySC } from './steps-chart.styled';
import moment from 'moment';
import {
  CIRCLE_CHART_GRADIENT_LEVELS,
  getAverageStepsFromData,
  getPercentage,
  getRecordStepsFromData,
  getSummaryStepsFromData,
  getSummaryStepsGoalFromData,
} from '../../../../../helpers/behavioral-helpers';
//@ts-ignore
import { CircleProgress } from 'react-gradient-progress';
import { TBehavioralTimelineStepsItem } from 'types/behavioral-data';
import { FormattedMessage } from 'react-intl';
import { ReactComponent as StarIcon } from '../../../../../assets/svg/icon-star.svg';

interface StepsChartSummaryProps {
  selectedPeriod: string;
  data: TBehavioralTimelineStepsItem[];
}

const StepsChartSummary: React.FC<StepsChartSummaryProps> = ({ selectedPeriod, data }) => {
  const [percentage, setPercentage] = useState<number | undefined>(undefined);

  useEffect(() => {
    if (selectedPeriod === 'day' && data.length > 0) {
      const dayPercentage = getPercentage(
        Math.round(getSummaryStepsFromData(data)),
        Math.round(data[0].goal),
      );
      setPercentage(dayPercentage);
    }
  }, [selectedPeriod, data]);

  return (
    <StepCartSummarySC>
      {selectedPeriod === 'day' ? (
        <>
          <div className="progress-wrap">
            <div className="progress">
              <b className={percentage ? 'count' : 'count empty'}>
                {percentage ? percentage : '--'} %
              </b>
              {percentage !== undefined ? (
                <CircleProgress
                  percentage={percentage && percentage > 100 ? 100 : percentage}
                  width={115}
                  strokeWidth={8}
                  secondaryColor="#404974"
                  primaryColor={
                    percentage && percentage >= 100
                      ? CIRCLE_CHART_GRADIENT_LEVELS[2]
                      : percentage === undefined
                      ? CIRCLE_CHART_GRADIENT_LEVELS[3]
                      : percentage && percentage >= 51
                      ? CIRCLE_CHART_GRADIENT_LEVELS[1]
                      : CIRCLE_CHART_GRADIENT_LEVELS[0]
                  }
                />
              ) : (
                ''
              )}
            </div>
            <div className="count-global">
              {Math.round(getSummaryStepsFromData(data)).toLocaleString()}{' '}
              <FormattedMessage
                id="life-id.steps.n_records"
                values={{ n: Math.round(getSummaryStepsFromData(data)) }}
              />
            </div>
          </div>
          <div className="detailed">
            <div>
              <span className="label">
                <FormattedMessage id="life-id.day_goal" />
              </span>
              <span className="spacer" />
              <span className="count">{Math.round(data[0].goal).toLocaleString()}</span>
            </div>
          </div>
        </>
      ) : (
        <>
          <div className="average">
            <span className="label">
              {selectedPeriod === 'year' ? (
                <FormattedMessage id="life-id.month_average" />
              ) : (
                <FormattedMessage id="life-id.day_average" />
              )}
            </span>
            <span className="count">
              {Math.round(getAverageStepsFromData(data)).toLocaleString()}{' '}
              <FormattedMessage
                id="life-id.steps.n_records"
                values={{ n: Math.round(getAverageStepsFromData(data)) }}
              />
            </span>
          </div>
          <div className="detailed">
            <div>
              <span className="label">
                <FormattedMessage id="life-id.global_goal" />
              </span>
              <span className="spacer" />
              <span className="count">
                {Math.round(getSummaryStepsGoalFromData(data)).toLocaleString()}
              </span>
            </div>
            <div>
              <span className="label">
                <FormattedMessage id="life-id.global_steps_count" />
              </span>
              <span className="spacer" />
              <span className="count">
                {Math.round(getSummaryStepsFromData(data)).toLocaleString()}
              </span>
            </div>
            <div>
              <span className="label">
                <FormattedMessage id="life-id.personal_record" />: <StarIcon />{' '}
                {moment(getRecordStepsFromData(data).timestampTo).format('DD.MM.YYYY')}
              </span>
              <span className="spacer" />
              <span className="count">
                {Math.round(getRecordStepsFromData(data).value).toLocaleString()}
              </span>
            </div>
          </div>
        </>
      )}
    </StepCartSummarySC>
  );
};

export default StepsChartSummary;
